<template>
    <section class="main-content is-transparent">
        <div class="hero">
            <div class="hero-body">
                <h1
                    class="title is-2 is-uppercase has-text-primary has-text-weight-bold"
                >
                    Disclaimer
                </h1>
                <p>
                    <b>Ultimo aggiornamento 01 luglio 2023</b>
                </p>
                <p><strong>DISCLAIMER SITO WEB</strong></p>
                <p>
                    Le informazioni fornite da Nuovo Rinascimento APS ("noi") su
                    <a href="https://www.tempiodelfuturo.art"
                        >www.tempiodelfuturo.art</a
                    >
                    (il "Sito Web") e la nostra applicazione mobile sono solo a
                    scopo informativo generale. Tutte le informazioni suil Sito
                    ela nostra applicazione mobile sono fornite in buona fede,
                    tuttavia non forniamo alcuna dichiarazione o garanzia di
                    alcun tipo, espressa o implicita, in merito all'accuratezza,
                    adeguatezza, validità, affidabilità, disponibilità o
                    completezza di qualsiasi informazione suil Sito o la nostra
                    applicazione mobile. IN NESSUN CASO ABBIAMO ALCUNA
                    RESPONSABILITÀ VERSO L'UTENTE PER PERDITE O DANNI DI
                    QUALSIASI TIPO SUBITI COME RISULTATO DELL'UTILIZZO DIIL SITO
                    O LA NOSTRA APPLICAZIONE MOBILEO AFFIDAMENTO SU QUALSIASI
                    INFORMAZIONE FORNITA SUIL SITO E LA NOSTRA APPLICAZIONE
                    MOBILE. IL TUO USO DEL SITO E LA NOSTRA APPLICAZIONE MOBILEE
                    IL TUO AFFIDAMENTO SU QUALSIASI INFORMAZIONE SUL SITO E LA
                    NOSTRA APPLICAZIONE MOBILE È ESCLUSIVAMENTE A PROPRIO
                    RISCHIO.
                </p>
                <p><strong>DISCLAIMER LiNK ESTERNI</strong></p>
                <p>
                    Il Sito e la nostra applicazione mobile potrebbero contenere
                    (o potrebbe essere inviato tramite il Sito o la nostra
                    applicazione mobile) collegamenti ad altri siti Web o
                    contenuti appartenenti o provenienti da terzi o collegamenti
                    a siti Web e presenza di banner o altra pubblicità. Tali
                    collegamenti esterni non vengono indagati, monitorati o
                    controllati da noi per quanto riguarda l'accuratezza,
                    l'adeguatezza, la validità, l'affidabilità, la disponibilità
                    o la completezza. NON GARANTIAMO, APPROVIAMO, ASSUMIAMO O
                    ASSUMIAMO LA RESPONSABILITÀ PER L'ACCURATEZZA O
                    L'AFFIDABILITÀ DI QUALSIASI INFORMAZIONE OFFERTA DA SITI WEB
                    DI TERZE PARTI COLLEGATI TRAMITE IL SITO O QUALSIASI SITO
                    WEB O FUNZIONE COLLEGATA IN QUALSIASI BANNER O ALTRA
                    PUBBLICITÀ. NON SAREMO PARTE O IN ALCUN MODO RESPONSABILI
                    DEL MONITORAGGIO DI QUALSIASI TRANSAZIONE TRA L'UTENTE E
                    FORNITORI TERZI DI PRODOTTI O SERVIZI.
                </p>
                <h1
                    class="title is-2 is-uppercase has-text-primary has-text-weight-bold"
                >
                    {{ $t("terms.title") }}
                </h1>
                <p><b>Ultimo aggiornamento 01 luglio 2023</b></p>
                <p><strong>ACCORDO CON I NOSTRI TERMINI LEGALI</strong></p>
                <p>
                    Nuovo Rinascimento APS ("<b>noi</b>,"), associazione
                    culturale registrata in Italia in Via Luigi Nono, 7, 20154
                    Milano MI, Italy, Milano, Lombardia gestisce il sito web
                    <a href="https://www.tempiodelfuturo.art"
                        >www.tempiodelfuturo.art</a
                    >
                    (il " <b>Sito</b> "), nonché tutti gli altri prodotti e
                    servizi correlati che fanno riferimento o si collegano a
                    questi termini legali (i " <b>Termini legali</b> ")
                    (collettivamente, i " <b>Servizi</b> ").
                </p>
                <p>
                    Potete contattarci telefonicamente al (+39)3917700315, email
                    a amm.nuovorinascimentoitaliano@gmail.com, oppure via mail a
                    Via Luigi Nono, 7, 20154 Milano MI, Italia, Milano,
                    Lombardia 20154, Italia.
                </p>
                <p>
                    Le presenti Condizioni Legali costituiscono un accordo
                    giuridicamente vincolante stipulato tra te, personalmente o
                    per conto di un'entità (" <b>tu</b> "), e Nuovo Rinascimento
                    APS, riguardante il tuo accesso e utilizzo dei Servizi.
                    Accetti che accedendo ai Servizi, hai letto, compreso e
                    accettato di essere vincolato da tutte le presenti
                    Condizioni legali. SE NON ACCETTI TUTTI QUESTI TERMINI
                    LEGALI, ALLORA TI SARÀ ESPRESSAMENTE VIETATO UTILIZZARE I
                    SERVIZI E DEVI INTERROMPERE IMMEDIATAMENTE L'UTILIZZO.
                </p>
                <p>
                    Termini e condizioni aggiuntivi o documenti che possono
                    essere pubblicati sui Servizi di volta in volta sono qui
                    espressamente incorporati per riferimento. Ci riserviamo il
                    diritto, a nostra esclusiva discrezione, di apportare
                    periodicamente cambiamenti o modifiche alle presenti
                    Condizioni legali. Ti avviseremo di eventuali modifiche
                    aggiornando la data "Ultimo aggiornamento" delle presenti
                    Condizioni legali e rinunci a qualsiasi diritto di ricevere
                    un avviso specifico di ciascuna di tali modifiche. È tua
                    responsabilità rivedere periodicamente le presenti
                    Condizioni legali per rimanere informato sugli
                    aggiornamenti. Sarai soggetto a, e si riterrà che tu sia
                    stato messo a conoscenza e che abbia accettato, le modifiche
                    alle Condizioni legali riviste attraverso l'uso continuato
                    dei Servizi dopo la data di pubblicazione di tali Condizioni
                    legali riviste.
                </p>
                <p>
                    I Servizi sono destinati a utenti che abbiano almeno 13 anni
                    di età. Tutti gli utenti minorenni nella giurisdizione in
                    cui risiedono (generalmente di età inferiore ai 18 anni)
                    devono avere il permesso ed essere direttamente
                    supervisionati dal proprio genitore o tutore per utilizzare
                    i Servizi. Se sei minorenne, devi far leggere e accettare le
                    presenti Condizioni legali da un tuo genitore o tutore prima
                    di utilizzare i Servizi.
                </p>
                <p>
                    Ti consigliamo di stampare una copia delle presenti
                    Condizioni legali per i tuoi archivi.
                </p>
                <p><strong>SOMMARIO</strong></p>
                <p><a href="#services">1. I NOSTRI SERVIZI</a></p>
                <p><a href="#ip">2. DIRITTI DI PROPRIETÀ INTELLETTUALE</a></p>
                <p>
                    <a href="#userreps">3. DICHIARAZIONI DELL'UTENTE</a>
                </p>
                <p>
                    <a href="#userreg">4. REGISTRAZIONE UTENTE</a>
                    <a href="#products"></a>
                </p>
                <p>
                    <a href="#products">5. PRODOTTI</a>
                    <a href="#purchases"></a>
                </p>
                <p><a href="#purchases">6. ACQUISTI E PAGAMENTI</a></p>
                <p><a href="#returnyes">7. POLITICA DI RIMBORSO</a></p>
                <p><a href="#prohibited">8. ATTIVITÀ VIETATE</a></p>
                <p><a href="#ugc">9. CONTRIBUTI GENERATI DAGLI UTENTI</a></p>
                <p><a href="#license">10. LICENZA DI CONTRIBUTO</a></p>
                <p>
                    <a href="#thirdparty"
                        >11. SITI WEB E CONTENUTI DI TERZE PARTI</a
                    >
                    <a href="#advertisers"></a>
                </p>
                <p>
                    <a href="#sitemanage">12. GESTIONE DEI SERVIZI</a>
                    <a href="#ppyes"></a>
                </p>
                <p>
                    <a href="#ppno">13. INFORMATIVA SULLA PRIVACY</a>
                    <a href="#dmca"></a>
                </p>
                <p>
                    <a href="#terms">14. DURATA E RISOLUZIONE</a>
                    <a href="#modifications"></a>
                </p>
                <p>
                    <a href="#modifications">15. MODIFICHE E INTERRUZIONI</a>
                    <a href="#law"></a>
                </p>
                <p>
                    <a href="#law">16. LEGGE APPLICABILE</a>
                    <a href="#disputes"></a>
                </p>
                <p>
                    <a href="#disputes">17. RISOLUZIONE DELLE CONTROVERSIE</a>
                    <a href="#corrections"></a>
                </p>
                <p>
                    <a href="#corrections">18. CORREZIONI</a>
                    <a href="#disclaimer"></a>
                </p>
                <p>
                    <a href="#disclaimer">19. ESCLUSIONE DI RESPONSABILITÀ</a>
                    <a href="#liability"></a>
                </p>
                <p>
                    <a href="#liability">20. LIMITAZIONI DI RESPONSABILITÀ</a>
                    <a href="#indemnification"></a>
                </p>
                <p>
                    <a href="#indemnification">21. INDENNIZZO</a>
                    <a href="#userdata"></a>
                </p>
                <p>
                    <a href="#userdata">22. DATI DELL'UTENTE</a>
                    <a href="#electronic"></a>
                </p>
                <p>
                    <a href="#electronic"
                        >23. COMUNICAZIONI ELETTRONICHE, TRANSAZIONI E FIRME</a
                    >
                    <a href="#california"></a>
                </p>
                <p>
                    <a href="#california"
                        >24. UTENTI E RESIDENTI IN CALIFORNIA</a
                    >
                    <a href="#misc"></a>
                </p>
                <p><a href="#misc">25. VARIE</a> <a href="#contact"></a></p>
                <p><a href="#contact">26. CONTATTACI</a></p>
                <p id="services"><strong>1. I NOSTRI SERVIZI</strong></p>
                <p>
                    Le informazioni fornite durante l'utilizzo dei Servizi non
                    sono destinate alla distribuzione o all'utilizzo da parte di
                    qualsiasi persona o entità in qualsiasi giurisdizione o
                    paese in cui tale distribuzione o utilizzo sarebbe contrario
                    alla legge o ai regolamenti o che ci assoggetterebbe a
                    qualsiasi obbligo di registrazione all'interno di tale
                    giurisdizione o Paese. Di conseguenza, coloro che scelgono
                    di accedere ai Servizi da altri luoghi lo fanno di propria
                    iniziativa e sono gli unici responsabili del rispetto delle
                    leggi locali, se e nella misura in cui le leggi locali sono
                    applicabili.
                </p>
                <p>
                    I Servizi non sono personalizzati per conformarsi alle
                    normative specifiche del settore (Health Insurance
                    Portability and Accountability Act (HIPAA), Federal
                    Information Security Management Act (FISMA), ecc.), pertanto
                    se le tue interazioni fossero soggette a tali leggi,
                    potresti non utilizzare i Servizi. Non è possibile
                    utilizzare i Servizi in un modo che violi il
                    Gramm-Leach-Bliley Act (GLBA).
                </p>
                <p id="ip">
                    <strong>2. DIRITTI DI PROPRIETÀ INTELLETTUALE</strong>
                </p>
                <p><strong>La nostra proprietà intellettuale</strong></p>
                <p>
                    Siamo il proprietario o il licenziatario di tutti i diritti
                    di proprietà intellettuale nei nostri Servizi, inclusi tutto
                    il codice sorgente, i database, le funzionalità, il
                    software, i design di siti Web, audio, video, testo,
                    fotografie e grafica nei Servizi (collettivamente, il
                    "Contenuto" ), nonché i marchi commerciali, i marchi di
                    servizio e i loghi in essi contenuti (i "Marchi").
                </p>
                <p>
                    I nostri Contenuti e Marchi sono protetti dalle leggi sul
                    copyright e sui marchi (e vari altri diritti di proprietà
                    intellettuale e leggi sulla concorrenza sleale) e dai
                    trattati negli Stati Uniti e in tutto il mondo.
                </p>
                <p>
                    I Contenuti e i Marchi sono forniti all'interno o tramite i
                    Servizi "COSÌ COME SONO" esclusivamente per uso personale e
                    non commerciale.
                </p>
                <p><strong>Il tuo utilizzo dei nostri Servizi</strong></p>
                <p>
                    A condizione che tu rispetti le presenti Condizioni legali,
                    inclusa la sezione "
                    <a href="#prohibited">ATTIVITÀ PROIBITE</a> " di seguito, ti
                    concediamo una licenza non esclusiva, non trasferibile e
                    revocabile per:
                </p>
                <ul>
                    <li>accedere ai Servizi; E</li>
                    <li>
                        scaricare o stampare una copia di qualsiasi parte del
                        Contenuto a cui hai correttamente ottenuto l'accesso.
                    </li>
                </ul>
                <p>esclusivamente per uso personale e non commerciale.</p>
                <p>
                    Ad eccezione di quanto stabilito in questa sezione o altrove
                    nelle nostre Condizioni legali, nessuna parte dei Servizi e
                    nessun Contenuto o Marchio può essere copiato, riprodotto,
                    aggregato, ripubblicato, caricato, pubblicato, visualizzato
                    pubblicamente, codificato, tradotto, trasmesso, distribuito,
                    venduto , concessi in licenza o altrimenti sfruttati per
                    qualsiasi scopo commerciale, senza la nostra previa
                    autorizzazione scritta.
                </p>
                <p>
                    Se desideri utilizzare i Servizi, i Contenuti o i Marchi in
                    modo diverso da quanto stabilito in questa sezione o altrove
                    nelle nostre Condizioni legali, indirizza la tua richiesta
                    a: amm.nuovorinascimentoitaliano@gmail.com. Se mai ti
                    concedessimo il permesso di pubblicare, riprodurre o
                    visualizzare pubblicamente qualsiasi parte dei nostri
                    Servizi o Contenuti, devi identificarci come proprietari o
                    licenziatari dei Servizi, Contenuti o Marchi e assicurarti
                    che qualsiasi avviso di copyright o proprietà appaia o è
                    visibile pubblicando, riproducendo o visualizzando i nostri
                    Contenuti.
                </p>
                <p>
                    Ci riserviamo tutti i diritti non espressamente concessi
                    all'utente nei e sui Servizi, Contenuti e Marchi.
                </p>
                <p>
                    Qualsiasi violazione di questi Diritti di proprietà
                    intellettuale costituirà una violazione materiale delle
                    nostre Condizioni legali e il tuo diritto di utilizzare i
                    nostri Servizi cesserà immediatamente.
                </p>
                <p><strong>Le tue proposte</strong></p>
                <p>
                    Ti invitiamo a leggere attentamente questa sezione e la
                    sezione " <a href="#prohibited">ATTIVITÀ PROIBITE</a> "
                    prima di utilizzare i nostri Servizi per comprendere (a) i
                    diritti che ci concedi e (b) gli obblighi che hai quando
                    pubblichi o carichi contenuti tramite i Servizi.
                </p>
                <p>
                    <strong>Contributi:</strong> inviandoci direttamente
                    domande, commenti, suggerimenti, idee, feedback o altre
                    informazioni sui Servizi ("Contributi"), accetti di
                    assegnarci tutti i diritti di proprietà intellettuale su
                    tali Contributi. Accetti che saremo proprietari di questo
                    Materiale inviato e avremo diritto al suo utilizzo e alla
                    sua diffusione illimitati per qualsiasi scopo legale,
                    commerciale o altro, senza riconoscimento o compenso nei
                    tuoi confronti.
                </p>
                <p>
                    <strong
                        >Sei responsabile di ciò che pubblichi o
                        carichi:</strong
                    >
                    Inviandoci Contributi tramite qualsiasi parte dei Servizi:
                </p>
                <ul>
                    <li>
                        confermi di aver letto e accettato le nostre "
                        <a href="#prohibited">ATTIVITÀ PROIBITE</a> " e di non
                        pubblicare, inviare, pubblicare, caricare o trasmettere
                        attraverso i Servizi alcun Contributo illegale, molesto,
                        odioso, dannoso, diffamatorio, osceno, bullismo,
                        offensivo, discriminatorio , minaccioso nei confronti di
                        qualsiasi persona o gruppo, sessualmente esplicito,
                        falso, impreciso, ingannevole o fuorviante;
                    </li>
                    <li>
                        nella misura consentita dalla legge applicabile,
                        rinunciare a tutti i diritti morali su tale Contributo;
                    </li>
                    <li>
                        garantisci che tali Contributi sono originali per te o
                        che disponi dei diritti e delle licenze necessari per
                        inviare tali Contributi e che hai piena autorità per
                        concederci i diritti sopra menzionati in relazione ai
                        tuoi Contributi; E
                    </li>
                    <li>
                        garantisce e dichiara che i tuoi Contributi non
                        costituiscono informazioni riservate.
                    </li>
                </ul>
                <p>
                    Sei l'unico responsabile dei tuoi Contributi e accetti
                    espressamente di rimborsarci tutte le perdite che potremmo
                    subire a causa della tua violazione di (a) questa sezione,
                    (b) i diritti di proprietà intellettuale di terzi o (c) la
                    legge applicabile .
                </p>
                <p id="userreps">
                    <strong
                        ><strong><strong>3.</strong>&nbsp;</strong>
                        DICHIARAZIONI DELL'UTENTE</strong
                    >
                </p>
                <p>
                    Utilizzando i Servizi, dichiari e garantisci che: (1) tutte
                    le informazioni di registrazione inviate saranno vere,
                    accurate, aggiornate e complete; (2) manterrai l'accuratezza
                    di tali informazioni e aggiornerai tempestivamente tali
                    informazioni di registrazione secondo necessità; (3) hai la
                    capacità giuridica e accetti di rispettare le presenti
                    Condizioni legali; (4) non hai meno di 13 anni; (5) non sei
                    minorenne nella giurisdizione in cui risiedi o, se
                    minorenne, hai ricevuto il permesso dei genitori per
                    utilizzare i Servizi; (6) non accederai ai Servizi tramite
                    mezzi automatizzati o non umani, sia tramite un bot,
                    sceneggiatura o altro; (7) non utilizzerai i Servizi per
                    scopi illegali o non autorizzati; e (8) l'utilizzo dei
                    Servizi non violerà alcuna legge o regolamento applicabile.
                </p>
                <p>
                    Se fornisci informazioni false, inaccurate, non aggiornate o
                    incomplete, abbiamo il diritto di sospendere o chiudere il
                    tuo account e rifiutare qualsiasi utilizzo attuale o futuro
                    dei Servizi (o qualsiasi parte di essi).
                </p>
                <p id="userreg">
                    <strong
                        ><strong><strong>4.</strong>&nbsp;</strong>
                        REGISTRAZIONE UTENTE</strong
                    >
                </p>
                <p>
                    Potrebbe essere necessario registrarsi per utilizzare i
                    Servizi. Accetti di mantenere riservata la tua password e
                    sarai responsabile di qualsiasi utilizzo del tuo account e
                    della tua password. Ci riserviamo il diritto di rimuovere,
                    rivendicare o modificare un nome utente selezionato se
                    determiniamo, a nostra esclusiva discrezione, che tale nome
                    utente è inappropriato, osceno o altrimenti discutibile.
                </p>
                <p id="products"><strong>5. PRODOTTI</strong></p>
                <p>
                    Tutti i prodotti sono soggetti a disponibilità. Ci
                    riserviamo il diritto di interrompere la produzione di
                    qualsiasi prodotto in qualsiasi momento e per qualsiasi
                    motivo. I prezzi di tutti i prodotti sono soggetti a
                    modifiche.
                </p>
                <p id="purchases">
                    <strong
                        ><strong><strong>6.</strong>&nbsp;</strong> ACQUISTI E
                        PAGAMENTI</strong
                    >
                </p>
                <p>Accettiamo le seguenti forme di pagamento:</p>
                <p>- Visa</p>
                <p>- Mastercard</p>
                <p>- PayPal</p>
                <p>
                    Accetti di fornire informazioni di acquisto e account
                    aggiornate, complete e accurate per tutti gli acquisti
                    effettuati tramite i Servizi. Accetti inoltre di aggiornare
                    tempestivamente le informazioni sull'account e sul
                    pagamento, inclusi l'indirizzo e-mail, il metodo di
                    pagamento e la data di scadenza della carta di pagamento, in
                    modo che possiamo completare le tue transazioni e
                    contattarti secondo necessità. L'imposta sulle vendite verrà
                    aggiunta al prezzo degli acquisti come ritenuto richiesto da
                    noi. Possiamo modificare i prezzi in qualsiasi momento.
                    Tutti i pagamenti dovranno essere effettuati in Euro.
                </p>
                <p>
                    Accetti di pagare tutte le spese ai prezzi in vigore per i
                    tuoi acquisti e tutte le spese di spedizione applicabili e
                    ci autorizzi ad addebitare al tuo fornitore di servizi di
                    pagamento prescelto tali importi al momento dell'ordine. Ci
                    riserviamo il diritto di correggere eventuali errori o
                    errori nei prezzi, anche se abbiamo già richiesto o ricevuto
                    il pagamento.
                </p>
                <p>
                    Ci riserviamo il diritto di rifiutare qualsiasi ordine
                    effettuato tramite i Servizi. Possiamo, a nostra esclusiva
                    discrezione, limitare o annullare le quantità acquistate per
                    persona, per nucleo familiare o per ordine. Queste
                    restrizioni possono includere ordini effettuati da o con lo
                    stesso account cliente, lo stesso metodo di pagamento e/o
                    ordini che utilizzano lo stesso indirizzo di fatturazione o
                    spedizione. Ci riserviamo il diritto di limitare o vietare
                    gli ordini che, a nostro esclusivo giudizio, sembrano essere
                    effettuati da rivenditori, rivenditori o distributori.
                </p>
                <p id="returnyes"><strong>7. POLITICA DI RIMBORSO</strong></p>
                <p>
                    Si prega di consultare la nostra Politica di restituzione
                    pubblicata sui Servizi prima di effettuare qualsiasi
                    acquisto.
                </p>
                <p id="prohibited">
                    <strong
                        ><strong><strong>8.</strong>&nbsp;</strong> ATTIVITÀ
                        VIETATE</strong
                    >
                </p>
                <p>
                    Non è possibile accedere o utilizzare i Servizi per scopi
                    diversi da quelli per i quali rendiamo disponibili i
                    Servizi. I Servizi non possono essere utilizzati in
                    relazione ad attività commerciali ad eccezione di quelle
                    specificatamente approvate o approvate da noi.
                </p>
                <p>Come utente dei Servizi, accetti di non:</p>
                <ul>
                    <li>
                        Recuperare sistematicamente dati o altri contenuti dai
                        Servizi per creare o compilare, direttamente o
                        indirettamente, una raccolta, compilazione, database o
                        directory senza il nostro consenso scritto.
                    </li>
                    <li>
                        Truffare, frodare o ingannare noi e gli altri utenti,
                        soprattutto tentando di apprendere informazioni
                        sensibili sull'account come le password degli utenti.
                    </li>
                    <li>
                        Aggirare, disabilitare o interferire in altro modo con
                        le funzionalità relative alla sicurezza dei Servizi,
                        comprese le funzionalità che impediscono o limitano
                        l'uso o la copia di qualsiasi Contenuto o impongono
                        limitazioni all'uso dei Servizi e/o del Contenuto in
                        essi contenuto.
                    </li>
                    <li>
                        Denigrare, offuscare o danneggiare in altro modo, a
                        nostro avviso, noi e/o i Servizi.
                    </li>
                    <li>
                        Utilizzare qualsiasi informazione ottenuta dai Servizi
                        per molestare, abusare o danneggiare un'altra persona.
                    </li>
                    <li>
                        Fare un uso improprio dei nostri servizi di supporto o
                        inviare false segnalazioni di abusi o cattiva condotta.
                    </li>
                    <li>
                        Utilizzare i Servizi in modo non conforme alle leggi o
                        ai regolamenti applicabili.
                    </li>
                    <li>
                        Partecipare a framing o collegamenti non autorizzati ai
                        Servizi.
                    </li>
                    <li>
                        Caricare o trasmettere (o tentare di caricare o
                        trasmettere) virus, cavalli di Troia o altro materiale,
                        compreso l'uso eccessivo di lettere maiuscole e spam
                        (pubblicazione continua di testo ripetitivo), che
                        interferisce con l'uso ininterrotto e il godimento dei
                        Servizi o modifica, compromette, interrompe, altera o
                        interferisce con l'uso, le caratteristiche, le funzioni,
                        il funzionamento o la manutenzione dei Servizi.
                    </li>
                    <li>
                        Impegnarsi in qualsiasi utilizzo automatizzato del
                        sistema, come l'utilizzo di script per inviare commenti
                        o messaggi, o l'utilizzo di data mining, robot o
                        strumenti simili di raccolta ed estrazione di dati.
                    </li>
                    <li>
                        Eliminare l'avviso sul copyright o altri diritti
                        proprietari da qualsiasi Contenuto.
                    </li>
                    <li>
                        Tentare di impersonare un altro utente o persona o
                        utilizzare il nome utente di un altro utente.
                    </li>
                    <li>
                        Caricare o trasmettere (o tentare di caricare o
                        trasmettere) qualsiasi materiale che funga da meccanismo
                        passivo o attivo di raccolta o trasmissione di
                        informazioni, inclusi, a titolo esemplificativo, formati
                        di scambio grafico chiaro ("gif"), pixel 1×1, web bug,
                        cookie o altri dispositivi simili (a volte definiti
                        "spyware" o "meccanismi di raccolta passiva" o "pcms").
                    </li>
                    <li>
                        Interferire, interrompere o creare un onere eccessivo
                        sui Servizi o sulle reti o sui servizi connessi ai
                        Servizi.
                    </li>
                    <li>
                        Molestare, infastidire, intimidire o minacciare i nostri
                        dipendenti o agenti impegnati nella fornitura di
                        qualsiasi parte dei Servizi all'utente.
                    </li>
                    <li>
                        Tentare di aggirare qualsiasi misura dei Servizi
                        progettata per impedire o limitare l'accesso ai Servizi
                        o a qualsiasi parte dei Servizi.
                    </li>
                    <li>
                        Copiare o adattare il software dei Servizi, incluso ma
                        non limitato a Flash, PHP, HTML, JavaScript o altro
                        codice.
                    </li>
                    <li>
                        Fatto salvo quanto consentito dalla legge applicabile,
                        decifrare, decompilare, disassemblare o decodificare
                        qualsiasi software che comprende o costituisce in
                        qualsiasi modo una parte dei Servizi.
                    </li>
                    <li>
                        Ad eccezione di quanto potrebbe essere il risultato
                        dell'utilizzo di un motore di ricerca standard o di un
                        browser Internet, utilizzare, lanciare, sviluppare o
                        distribuire qualsiasi sistema automatizzato, inclusi, a
                        titolo esemplificativo, qualsiasi spider, robot, utilità
                        cheat, scraper o lettore offline che acceda ai Servizi,
                        o utilizzare o avviare script o altri software non
                        autorizzati.
                    </li>
                    <li>
                        Utilizzare un agente d'acquisto o un agente d'acquisto
                        per effettuare acquisti sui Servizi.
                    </li>
                    <li>
                        Effettuare qualsiasi utilizzo non autorizzato dei
                        Servizi, inclusa la raccolta di nomi utente e/o
                        indirizzi e-mail degli utenti tramite mezzi elettronici
                        o di altro tipo allo scopo di inviare e-mail non
                        richieste o creare account utente con mezzi
                        automatizzati o con falsi pretesti.
                    </li>
                    <li>
                        Utilizzare i Servizi come parte di qualsiasi tentativo
                        di competere con noi o utilizzare in altro modo i
                        Servizi e/o i Contenuti per qualsiasi attività
                        generatrice di entrate o impresa commerciale.
                    </li>
                    <li>
                        Utilizzare i Servizi per pubblicizzare o offrire la
                        vendita di beni e servizi.
                    </li>
                    <li>Vendi o trasferisci in altro modo il tuo profilo.</li>
                </ul>
                <p id="ugc">
                    <strong
                        ><strong><strong>9.</strong>&nbsp;</strong> CONTRIBUTI
                        GENERATI DAGLI UTENTI</strong
                    >
                </p>
                <p>
                    I Servizi non offrono agli utenti la possibilità di inviare
                    o pubblicare contenuti. Potremmo fornirti l'opportunità di
                    creare, inviare, pubblicare, visualizzare, trasmettere,
                    eseguire, pubblicare, distribuire o trasmettere contenuti e
                    materiali a noi o sui Servizi, inclusi ma non limitati a
                    testo, scritti, video, audio, fotografie , grafica,
                    commenti, suggerimenti o informazioni personali o altro
                    materiale (collettivamente, "Contributi"). I Contributi
                    possono essere visualizzabili da altri utenti dei Servizi e
                    attraverso siti Web di terzi. Quando crei o rendi
                    disponibile qualsiasi Contributo, dichiari e garantisci che:
                </p>
                <ul>
                    <li>
                        La creazione, distribuzione, trasmissione,
                        visualizzazione pubblica o esecuzione e l'accesso, il
                        download o la copia dei tuoi Contributi non violano e
                        non violeranno i diritti di proprietà, inclusi ma non
                        limitati a copyright, brevetto, marchio, segreto
                        commerciale o diritti morali di terzi.
                    </li>
                    <li>
                        Sei il creatore e proprietario o possiedi le licenze, i
                        diritti, i consensi, le liberatorie e le autorizzazioni
                        necessarie per utilizzare e autorizzare noi, i Servizi e
                        altri utenti dei Servizi a utilizzare i tuoi Contributi
                        in qualsiasi modo contemplato dai Servizi e da questi
                        Termini legali.
                    </li>
                    <li>
                        Hai il consenso scritto, la liberatoria e/o
                        l'autorizzazione di ogni singola persona identificabile
                        nei tuoi Contributi a utilizzare il nome o le sembianze
                        di ciascuna singola persona identificabile per
                        consentire l'inclusione e l'utilizzo dei tuoi Contributi
                        in qualsiasi modo contemplato dalla Servizi e le
                        presenti Condizioni legali.
                    </li>
                    <li>
                        I tuoi contributi non sono falsi, imprecisi o
                        fuorvianti.
                    </li>
                    <li>
                        I tuoi Contributi non costituiscono pubblicità non
                        richiesta o non autorizzata, materiale promozionale,
                        schemi piramidali, lettere a catena, spam, mailing di
                        massa o altre forme di sollecitazione.
                    </li>
                    <li>
                        I tuoi Contributi non sono osceni, osceni, lascivi,
                        sporchi, violenti, molesti, calunniosi, calunniosi o
                        altrimenti discutibili (come stabilito da noi).
                    </li>
                    <li>
                        I tuoi Contributi non ridicolizzano, deridono,
                        denigrano, intimidiscono o abusano di nessuno.
                    </li>
                    <li>
                        I tuoi Contributi non vengono utilizzati per molestare o
                        minacciare (nel senso legale di questi termini)
                        qualsiasi altra persona e per promuovere la violenza
                        contro una specifica persona o classe di persone.
                    </li>
                    <li>
                        I tuoi Contributi non violano alcuna legge, regolamento
                        o regola applicabile.
                    </li>
                    <li>
                        I tuoi Contributi non violano la privacy o i diritti di
                        pubblicità di terze parti.
                    </li>
                    <li>
                        I tuoi Contributi non violano alcuna legge applicabile
                        in materia di pornografia infantile, o altrimenti
                        destinati a proteggere la salute o il benessere dei
                        minori.
                    </li>
                    <li>
                        I tuoi Contributi non includono commenti offensivi
                        collegati a razza, origine nazionale, genere, preferenza
                        sessuale o handicap fisico.
                    </li>
                    <li>
                        I tuoi Contributi non violano in altro modo, né si
                        collegano a materiale che viola, alcuna disposizione
                        delle presenti Condizioni legali o qualsiasi legge o
                        regolamento applicabile.
                    </li>
                </ul>
                <p>
                    Qualsiasi utilizzo dei Servizi in violazione di quanto sopra
                    viola le presenti Condizioni legali e può comportare, tra le
                    altre cose, la cessazione o la sospensione dei tuoi diritti
                    di utilizzo dei Servizi.
                </p>
                <p id="licensing">
                    <strong
                        ><strong><strong>10.</strong>&nbsp;</strong> LICENZA DI
                        CONTRIBUTO</strong
                    >
                </p>
                <p>
                    Tu e i Servizi accettate che possiamo accedere, archiviare,
                    elaborare e utilizzare tutte le informazioni e i dati
                    personali forniti e le vostre scelte (comprese le
                    impostazioni).
                </p>
                <p>
                    Inviando suggerimenti o altri feedback riguardanti i
                    Servizi, accetti che possiamo utilizzare e condividere tali
                    feedback per qualsiasi scopo senza alcun compenso per te.
                </p>
                <p>
                    Non rivendichiamo alcuna proprietà sui tuoi Contributi.
                    Mantieni la piena proprietà di tutti i tuoi Contributi e di
                    tutti i diritti di proprietà intellettuale o altri diritti
                    proprietari associati ai tuoi Contributi. Non siamo
                    responsabili per eventuali dichiarazioni o rappresentazioni
                    nei Contributi da te forniti in qualsiasi area dei Servizi.
                    Sei l'unico responsabile dei tuoi Contributi ai Servizi e
                    accetti espressamente di esonerarci da ogni responsabilità e
                    di astenerci da qualsiasi azione legale contro di noi in
                    merito ai tuoi Contributi.
                </p>
                <p id="thirdparty">
                    <strong
                        ><strong>11.</strong> &nbsp;SITI WEB E CONTENUTI DI
                        TERZE PARTI</strong
                    >
                </p>
                <p>
                    I Servizi possono contenere (o potrebbero essere inviati
                    tramite il Sito) collegamenti ad altri siti Web ("Siti Web
                    di terze parti") nonché articoli, fotografie, testi,
                    grafica, immagini, disegni, musica, audio, video,
                    informazioni, applicazioni , software e altri contenuti o
                    elementi appartenenti o originati da terze parti ("Contenuti
                    di terze parti"). Tali siti Web di terze parti e Contenuti
                    di terze parti non vengono indagati, monitorati o
                    controllati da noi per quanto riguarda l'accuratezza,
                    l'adeguatezza o la completezza e non siamo responsabili per
                    eventuali siti Web di terze parti a cui si accede tramite i
                    Servizi o qualsiasi Contenuto di terze parti pubblicato su,
                    disponibile tramite o installato dai Servizi, inclusi
                    contenuto, accuratezza, offensività, opinioni, affidabilità,
                    pratiche sulla privacy, o altre politiche di o contenute nei
                    Siti Web di terze parti o nei Contenuti di terze parti.
                    L'inclusione, il collegamento o l'autorizzazione all'uso o
                    all'installazione di siti Web di terze parti o di qualsiasi
                    contenuto di terze parti non implica l'approvazione o
                    l'avallo degli stessi da parte nostra. Se decidi di
                    abbandonare i Servizi e accedere ai Siti Web di Terze Parti
                    o di utilizzare o installare Contenuti di Terze Parti, lo
                    fai a tuo rischio e pericolo e dovresti essere consapevole
                    che le presenti Condizioni Legali non regolano più. Dovresti
                    rivedere i termini e le politiche applicabili, comprese le
                    pratiche sulla privacy e sulla raccolta dei dati, di
                    qualsiasi sito web a cui navighi dai Servizi o relativo a
                    qualsiasi applicazione che utilizzi o installi dai Servizi.
                    Qualsiasi acquisto effettuato tramite siti Web di terze
                    parti avverrà tramite altri siti Web e da altre società e
                    non ci assumiamo alcuna responsabilità in relazione a tali
                    acquisti che sono esclusivamente tra te e la terza parte
                    applicabile. Accetti e riconosci che non approviamo i
                    prodotti o servizi offerti su siti Web di terze parti e ci
                    riterrai incolpevoli da qualsiasi danno causato dal tuo
                    acquisto di tali prodotti o servizi. Inoltre, ci riterrai
                    incolpevoli da eventuali perdite subite da te o danni
                    causati a te relativi o risultanti in qualsiasi modo da
                    qualsiasi Contenuto di terze parti o da qualsiasi contatto
                    con siti Web di terze parti. e non ci assumiamo alcuna
                    responsabilità in relazione a tali acquisti che sono
                    esclusivamente tra te e la terza parte applicabile. Accetti
                    e riconosci che non approviamo i prodotti o servizi offerti
                    su siti Web di terze parti e ci riterrai incolpevoli da
                    qualsiasi danno causato dal tuo acquisto di tali prodotti o
                    servizi. Inoltre, ci riterrai incolpevoli da eventuali
                    perdite subite da te o danni causati a te relativi o
                    risultanti in qualsiasi modo da qualsiasi Contenuto di terze
                    parti o da qualsiasi contatto con siti Web di terze parti. e
                    non ci assumiamo alcuna responsabilità in relazione a tali
                    acquisti che sono esclusivamente tra te e la terza parte
                    applicabile. Accetti e riconosci che non approviamo i
                    prodotti o servizi offerti su siti Web di terze parti e ci
                    riterrai incolpevoli da qualsiasi danno causato dal tuo
                    acquisto di tali prodotti o servizi. Inoltre, ci riterrai
                    incolpevoli da eventuali perdite subite da te o danni
                    causati a te relativi o risultanti in qualsiasi modo da
                    qualsiasi Contenuto di terze parti o da qualsiasi contatto
                    con siti Web di terze parti. Accetti e riconosci che non
                    approviamo i prodotti o servizi offerti su siti Web di terze
                    parti e ci riterrai incolpevoli da qualsiasi danno causato
                    dal tuo acquisto di tali prodotti o servizi. Inoltre, ci
                    riterrai incolpevoli da eventuali perdite subite da te o
                    danni causati a te relativi o risultanti in qualsiasi modo
                    da qualsiasi Contenuto di terze parti o da qualsiasi
                    contatto con siti Web di terze parti. Accetti e riconosci
                    che non approviamo i prodotti o servizi offerti su siti Web
                    di terze parti e ci riterrai incolpevoli da qualsiasi danno
                    causato dal tuo acquisto di tali prodotti o servizi.
                    Inoltre, ci riterrai incolpevoli da eventuali perdite subite
                    da te o danni causati a te relativi o risultanti in
                    qualsiasi modo da qualsiasi Contenuto di terze parti o da
                    qualsiasi contatto con siti Web di terze parti.
                </p>
                <p id="sitemanage">
                    <strong
                        ><strong><strong>12.</strong>&nbsp;</strong> GESTIONE
                        DEI SERVIZI</strong
                    >
                </p>
                <p>
                    Ci riserviamo il diritto, ma non l'obbligo, di: (1)
                    monitorare i Servizi per eventuali violazioni delle presenti
                    Condizioni legali; (2) intraprendere le opportune azioni
                    legali contro chiunque, a nostra esclusiva discrezione,
                    violi la legge o le presenti Condizioni legali, incluso, a
                    titolo esemplificativo, la segnalazione di tale utente alle
                    autorità preposte all'applicazione della legge; (3) a nostra
                    esclusiva discrezione e senza limitazioni, rifiutare,
                    limitare l'accesso, limitare la disponibilità o disabilitare
                    (nella misura in cui è tecnologicamente fattibile) qualsiasi
                    dei tuoi Contributi o parte di essi; (4) a nostra esclusiva
                    discrezione e senza limitazioni, avvisi o responsabilità,
                    rimuovere dai Servizi o altrimenti disabilitare tutti i file
                    e i contenuti di dimensioni eccessive o che siano in
                    qualsiasi modo gravosi per i nostri sistemi; e (5) gestire
                    in altro modo i Servizi in modo tale da proteggere i nostri
                    diritti e proprietà e facilitare il corretto funzionamento
                    dei Servizi.
                </p>
                <p id="ppno">
                    <strong
                        ><strong>13.</strong> INFORMATIVA SULLA PRIVACY</strong
                    >
                </p>
                <p>
                    Abbiamo a cuore la privacy e la sicurezza dei dati.
                    Utilizzando i Servizi, accetti di essere vincolato dalla
                    nostra Informativa sulla privacy pubblicata sui Servizi, che
                    è incorporata nelle presenti Condizioni legali. Tieni
                    presente che i Servizi sono ospitati in Italia e in Europa.
                    Se accedi ai Servizi da qualsiasi altra regione del mondo
                    con leggi o altri requisiti che regolano la raccolta, l'uso
                    o la divulgazione dei dati personali che differiscono dalle
                    leggi applicabili in Italia e in Europa, attraverso l'uso
                    continuato dei Servizi, stai trasferendo i tuoi dati in
                    Italia e in Europa e acconsenti espressamente al
                    trasferimento e al trattamento dei tuoi dati in Italia e in
                    Europa. Inoltre, non accettiamo, richiediamo o sollecitiamo
                    consapevolmente informazioni da bambini né commercializziamo
                    consapevolmente ai bambini. Perciò,
                </p>
                <p id="terms">
                    <strong
                        ><strong><strong>14.</strong>&nbsp;</strong> DURATA E
                        RISOLUZIONE</strong
                    >
                </p>
                <p>
                    Le presenti Condizioni legali rimarranno in vigore a tutti
                    gli effetti durante l'utilizzo dei Servizi. SENZA LIMITARE
                    QUALSIASI ALTRA DISPOSIZIONE DEI PRESENTI TERMINI LEGALI, CI
                    RISERVIAMO IL DIRITTO DI, A NOSTRA UNICA DISCREZIONE E SENZA
                    PREAVVISO O RESPONSABILITÀ, NEGARE L'ACCESSO E L'UTILIZZO
                    DEI SERVIZI (INCLUSO IL BLOCCO DI ALCUNI INDIRIZZI IP), A
                    QUALSIASI PERSONA PER QUALSIASI MOTIVO O PER NESSUN MOTIVO,
                    INCLUSO SENZA LIMITAZIONE LA VIOLAZIONE DI QUALSIASI
                    DICHIARAZIONE, GARANZIA O PATTO CONTENUTO IN QUESTI TERMINI
                    LEGALI O DI QUALSIASI LEGGE O REGOLAMENTO APPLICABILE.
                    POSSIAMO TERMINARE IL TUO UTILIZZO O PARTECIPAZIONE AI
                    SERVIZI O ELIMINARE IL TUO ACCOUNT E QUALSIASI CONTENUTO O
                    INFORMAZIONE PUBBLICATO IN QUALSIASI MOMENTO, SENZA AVVISO,
                    A NOSTRA UNICA DISCREZIONE.
                </p>
                <p>
                    Se chiudiamo o sospendiamo il tuo account per qualsiasi
                    motivo, ti è vietato registrarti e creare un nuovo account
                    con il tuo nome, un nome falso o preso in prestito o il nome
                    di terzi, anche se potresti agire per conto di terzi festa.
                    Oltre a chiudere o sospendere il tuo account, ci riserviamo
                    il diritto di intraprendere azioni legali appropriate,
                    incluso, senza limitazioni, il ricorso a rimedi civili,
                    penali e ingiuntivi.
                </p>
                <p id="modifications">
                    <strong
                        ><strong><strong>15.</strong>&nbsp;</strong> MODIFICHE E
                        INTERRUZIONI</strong
                    >
                </p>
                <p>
                    Ci riserviamo il diritto di cambiare, modificare o rimuovere
                    i contenuti dei Servizi in qualsiasi momento o per qualsiasi
                    motivo a nostra esclusiva discrezione senza preavviso.
                    Tuttavia, non abbiamo alcun obbligo di aggiornare le
                    informazioni sui nostri Servizi. Ci riserviamo inoltre il
                    diritto di modificare o interrompere tutti o parte dei
                    Servizi senza preavviso in qualsiasi momento. Non saremo
                    responsabili nei confronti dell'utente o di terzi per
                    eventuali modifiche, variazioni di prezzo, sospensione o
                    interruzione dei Servizi.
                </p>
                <p>
                    Non possiamo garantire che i Servizi saranno disponibili in
                    ogni momento. Potremmo riscontrare problemi hardware,
                    software o di altro tipo o dover eseguire interventi di
                    manutenzione relativi ai Servizi, con conseguenti
                    interruzioni, ritardi o errori. Ci riserviamo il diritto di
                    cambiare, rivedere, aggiornare, sospendere, interrompere o
                    modificare in altro modo i Servizi in qualsiasi momento o
                    per qualsiasi motivo senza preavviso. Accetti che non
                    abbiamo alcuna responsabilità per eventuali perdite, danni o
                    inconvenienti causati dalla tua incapacità di accedere o
                    utilizzare i Servizi durante qualsiasi periodo di inattività
                    o interruzione dei Servizi. Nulla di quanto contenuto nelle
                    presenti Condizioni legali potrà essere interpretato in modo
                    da obbligarci a mantenere e supportare i Servizi o a fornire
                    eventuali correzioni, aggiornamenti o rilasci in relazione
                    ad essi.
                </p>
                <p id="law">
                    <strong
                        ><strong><strong>16.</strong>&nbsp;</strong> LEGGE
                        APPLICABILE</strong
                    >
                </p>
                <p>
                    Le presenti Condizioni Legali sono regolate e interpretate
                    secondo le leggi italiane ed è espressamente escluso l'uso
                    della Convenzione dei Contratti delle Nazioni Unite per la
                    Vendita Internazionale di Beni. Se la tua residenza abituale
                    è nell'UE e sei un consumatore, possiedi inoltre la
                    protezione fornita dalle disposizioni obbligatorie della
                    legge del tuo paese di residenza. Nuovo Rinascimento APS e
                    voi stessi accettate di sottoporvi alla giurisdizione non
                    esclusiva dei tribunali di Milano, il che significa che
                    potrete avanzare un reclamo per difendere i vostri diritti
                    di protezione dei consumatori in relazione alle presenti
                    Condizioni Legali in Italia, o nel paese dell'UE in cui
                    risiedi.
                </p>
                <p id="disputes">
                    <strong
                        ><strong><strong>17.</strong>&nbsp;</strong> RISOLUZIONE
                        DELLE CONTROVERSIE</strong
                    >
                </p>
                <p><strong>Negoziati informali</strong></p>
                <p>
                    Per accelerare la risoluzione e controllare il costo di
                    qualsiasi controversia, controversia o reclamo relativo alle
                    presenti Condizioni legali (ciascuna una "Controversia" e
                    collettivamente le "Controversie") promossa da te o da noi
                    (singolarmente, una "Parte" e collettivamente, le "Parti"),
                    le Parti convengono di tentare innanzitutto di negoziare
                    qualsiasi Controversia (ad eccezione delle Controversie
                    espressamente previste di seguito) in modo informale per
                    almeno 60 giorni prima di avviare l'arbitrato. Tali
                    negoziati informali iniziano previa comunicazione scritta da
                    una Parte all'altra Parte.
                </p>
                <p><strong>Arbitrato vincolante</strong></p>
                <p>
                    Qualsiasi controversia derivante dai rapporti tra le Parti
                    delle presenti Condizioni Legali sarà risolta da un arbitro
                    che sarà scelto in conformità con l'Arbitrato e il
                    Regolamento Interno della Corte Arbitrale Europea facente
                    parte del Centro Europeo di Arbitrato con sede a Strasburgo.
                    , e che sono in vigore al momento del deposito della domanda
                    di arbitrato, e di cui l'adozione della presente clausola
                    costituisce accettazione. La sede dell'arbitrato sarà
                    l'Italia. La lingua del procedimento sarà italiana. La
                    normativa applicabile in materia di diritto sostanziale è
                    quella italiana.
                </p>
                <p><strong>Restrizioni</strong></p>
                <p>
                    Le Parti convengono che qualsiasi arbitrato sarà limitato
                    alla Controversia tra le Parti individualmente. Nella misura
                    massima consentita dalla legge, (a) nessun arbitrato sarà
                    unito ad altri procedimenti; (b) non esiste il diritto o
                    l'autorità di arbitrare una Controversia sulla base di
                    un'azione collettiva o di utilizzare procedure di azione
                    collettiva; e (c) non esiste alcun diritto o autorità
                    affinché qualsiasi Controversia venga portata in presunta
                    capacità rappresentativa per conto del pubblico in generale
                    o di qualsiasi altra persona.
                </p>
                <p>
                    <strong
                        >Eccezioni alle negoziazioni informali e
                        all'arbitrato</strong
                    >
                </p>
                <p>
                    Le Parti convengono che le seguenti Controversie non sono
                    soggette alle disposizioni di cui sopra relative alle
                    negoziazioni informali di arbitrato vincolante: (a)
                    qualsiasi Controversia che cerchi di far rispettare o
                    proteggere, o riguardante la validità di, qualsiasi diritto
                    di proprietà intellettuale di una Parte; (b) qualsiasi
                    controversia relativa o derivante da accuse di furto,
                    pirateria, violazione della privacy o utilizzo non
                    autorizzato; e (c) qualsiasi richiesta di provvedimento
                    ingiuntivo. Se questa disposizione viene ritenuta illegale o
                    inapplicabile, nessuna delle Parti sceglierà di arbitrare
                    qualsiasi Controversia che rientri in quella parte di questa
                    disposizione ritenuta illegale o inapplicabile e tale
                    Controversia sarà decisa da un tribunale della giurisdizione
                    competente all'interno dei tribunali elencati per
                    giurisdizione di cui sopra,
                </p>
                <p id="corrections">
                    <strong
                        ><strong><strong>18.</strong>&nbsp;</strong>
                        CORREZIONI</strong
                    >
                </p>
                <p>
                    Potrebbero essere presenti informazioni sui Servizi che
                    contengono errori tipografici, imprecisioni o omissioni,
                    incluse descrizioni, prezzi, disponibilità e varie altre
                    informazioni. Ci riserviamo il diritto di correggere
                    eventuali errori, inesattezze o omissioni e di modificare o
                    aggiornare le informazioni sui Servizi in qualsiasi momento,
                    senza preavviso.
                </p>
                <p id="disclaimer">
                    <strong
                        ><strong>19.</strong> ESCLUSIONE DI
                        RESPONSABILITÀ</strong
                    >
                </p>
                <p>
                    I SERVIZI SONO FORNITI COSÌ COME SONO E COME DISPONIBILI.
                    ACCETTI CHE L'UTILIZZO DEI SERVIZI SARÀ A TUO ESCLUSIVO
                    RISCHIO. NELLA MISURA MASSIMA CONSENTITA DALLA LEGGE,
                    DECLINIAMO OGNI GARANZIA, ESPLICITA O IMPLICITA, IN
                    CONNESSIONE AI SERVIZI E AL SUO UTILIZZO, INCLUSE, SENZA
                    LIMITAZIONE, LE GARANZIE IMPLICITE DI COMMERCIABILITÀ,
                    IDONEITÀ PER UNO SCOPO PARTICOLARE E NON VIOLAZIONE. NON
                    FORNIAMO ALCUNA GARANZIA O DICHIARAZIONE CIRCA L'ACCURATEZZA
                    O LA COMPLETEZZA DEL CONTENUTO DEI SERVIZI O DEL CONTENUTO
                    DI EVENTUALI SITI WEB O APPLICAZIONI MOBILI COLLEGATE AI
                    SERVIZI E NON CI ASSUMEREMO ALCUNA RESPONSABILITÀ PER
                    EVENTUALI (1) ERRORI, ERRORI O IMPRECISIONI DEI CONTENUTI E
                    MATERIALI, (2) LESIONI PERSONALI O DANNI ALLE PROPRIETÀ, DI
                    QUALSIASI NATURA, DERIVANTI DAL VOSTRO ACCESSO E UTILIZZO
                    DEI SERVIZI, (3) QUALSIASI ACCESSO O UTILIZZO NON
                    AUTORIZZATO DEI NOSTRI SERVER SICURI E/O TUTTE LE
                    INFORMAZIONI PERSONALI E/O INFORMAZIONI FINANZIARIE IVI
                    MEMORIZZATE, (4) QUALSIASI INTERRUZIONE O CESSAZIONE DELLA
                    TRASMISSIONE A O DAI SERVIZI, (5) QUALSIASI BUG, ​​VIRUS,
                    CAVALLI DI TROJAN O SIMILI CHE POSSONO ESSERE TRASMESSI A O
                    ATTRAVERSO I SERVIZI DA QUALSIASI TERZA PARTE, E/O (6)
                    QUALSIASI ERRORE O OMISSIONE IN QUALSIASI CONTENUTO E
                    MATERIALE O PER QUALSIASI PERDITA O DANNO DI QUALSIASI TIPO
                    SOSTENUTO COME RISULTATO DELL'UTILIZZO DI QUALSIASI
                    CONTENUTO PUBBLICATO, TRASMESSO O ALTRIMENTI RESO
                    DISPONIBILE TRAMITE I SERVIZI. NON GARANTIAMO, APPROVIAMO,
                    ASSUMIAMO O ASSUMIAMO RESPONSABILITÀ PER QUALSIASI PRODOTTO
                    O SERVIZIO PUBBLICIZZATO O OFFERTO DA TERZI ATTRAVERSO I
                    SERVIZI, QUALSIASI SITO WEB CON COLLEGAMENTO IPERTENSIVO, O
                    QUALSIASI SITO WEB O APPLICAZIONE MOBILE PRESENTE IN
                    QUALSIASI BANNER O ALTRA PUBBLICITÀ, E NON SAREMO PARTE O IN
                    ALCUN MODO RESPONSABILE DEL MONITORAGGIO DI QUALSIASI
                    TRANSAZIONE TRA L'UTENTE E QUALSIASI FORNITORE DI PRODOTTI O
                    SERVIZI DI TERZE PARTI. COME PER L'ACQUISTO DI UN PRODOTTO O
                    SERVIZIO TRAMITE QUALSIASI MEZZO O IN QUALSIASI AMBIENTE, È
                    NECESSARIO USARE IL MIGLIOR GIUDIZIO ED ESERCITARE
                    ATTENZIONE DOVE APPROPRIATO.
                </p>
                <p id="liability">
                    <strong
                        ><strong><strong>20.</strong>&nbsp;</strong> LIMITAZIONI
                        DI RESPONSABILITÀ</strong
                    >
                </p>
                <p>
                    IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS
                    BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT,
                    INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR
                    PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS
                    OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE OF THE
                    SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF
                    SUCH DAMAGES. NOTWITHSTANDING ANYTHING TO THE CONTRARY
                    CONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY CAUSE
                    WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT
                    ALL TIMES BE LIMITED TO THE AMOUNT PAID, IF ANY, BY YOU TO
                    US.&nbsp;CERTAIN US STATE LAWS AND INTERNATIONAL LAWS DO NOT
                    ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR
                    LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU,
                    SOME OR ALL OF THE ABOVE DISCLAIMERS OR LIMITATIONS MAY NOT
                    APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS.
                </p>
                <p id="indemnification">
                    <strong
                        ><strong><strong>21.</strong>&nbsp;</strong>
                        INDENNIZZO</strong
                    >
                </p>
                <p>
                    Accetti di difendere, indennizzare e tenere indenni noi,
                    comprese le nostre filiali, affiliate e tutti i nostri
                    rispettivi funzionari, agenti, partner e dipendenti, da e
                    contro qualsiasi perdita, danno, responsabilità, reclamo o
                    richiesta, inclusi avvocati ragionevoli ' commissioni e
                    spese sostenute da terzi a causa o derivanti da: (1)
                    utilizzo dei Servizi; (2) violazione delle presenti
                    Condizioni legali; (3) qualsiasi violazione delle vostre
                    dichiarazioni e garanzie stabilite nelle presenti Condizioni
                    legali; (4) violazione dei diritti di terzi, inclusi ma non
                    limitati ai diritti di proprietà intellettuale; o (5)
                    qualsiasi atto palesemente dannoso nei confronti di
                    qualsiasi altro utente dei Servizi con cui ti sei connesso
                    tramite i Servizi. Nonostante quanto sopra, ci riserviamo il
                    diritto, a vostre spese, ad assumere la difesa e il
                    controllo esclusivi di qualsiasi questione per la quale sei
                    tenuto a indennizzarci e accetti di collaborare, a tue
                    spese, con la nostra difesa di tali pretese. Faremo ogni
                    ragionevole sforzo per informarti di qualsiasi reclamo,
                    azione o procedimento soggetto a questo indennizzo non
                    appena ne verremo a conoscenza.
                </p>
                <p id="userdata">
                    <strong
                        ><strong><strong>22.</strong>&nbsp;</strong> DATI
                        DELL'UTENTE</strong
                    >
                </p>
                <p>
                    Conserveremo alcuni dati che trasmetti ai Servizi allo scopo
                    di gestire le prestazioni dei Servizi, nonché i dati
                    relativi al tuo utilizzo dei Servizi. Sebbene eseguiamo
                    regolarmente backup di routine dei dati, sei l'unico
                    responsabile di tutti i dati che trasmetti o che si
                    riferiscono a qualsiasi attività che hai intrapreso
                    utilizzando i Servizi. Accetti che non avremo alcuna
                    responsabilità nei tuoi confronti per qualsiasi perdita o
                    corruzione di tali dati e con la presente rinunci a
                    qualsiasi diritto di azione contro di noi derivante da tale
                    perdita o corruzione di tali dati.
                </p>
                <p id="electronic">
                    <strong
                        ><strong><strong>23.</strong>&nbsp;</strong>
                        COMUNICAZIONI ELETTRONICHE, TRANSAZIONI E FIRME</strong
                    >
                </p>
                <p>
                    La visita dei Servizi, l'invio di e-mail e il completamento
                    di moduli online costituiscono comunicazioni elettroniche.
                    Acconsenti a ricevere comunicazioni elettroniche e accetti
                    che tutti gli accordi, avvisi, divulgazioni e altre
                    comunicazioni che ti forniamo elettronicamente, via e-mail e
                    sui Servizi, soddisfino qualsiasi requisito legale che tale
                    comunicazione sia in forma scritta. CON LA PRESENTE ACCETTI
                    L'UTILIZZO DI FIRME ELETTRONICHE, CONTRATTI, ORDINI E ALTRI
                    DOCUMENTI, E LA CONSEGNA ELETTRONICA DI AVVISI, POLITICHE E
                    REGISTRAZIONI DELLE TRANSAZIONI INIZIATE O COMPLETATE DA NOI
                    O TRAMITE I SERVIZI. Con la presente rinunci a qualsiasi
                    diritto o requisito previsto da statuti, regolamenti, norme,
                    ordinanze,
                </p>
                <p id="california">
                    <strong
                        ><strong><strong>24.</strong>&nbsp;</strong> UTENTI E
                        RESIDENTI IN CALIFORNIA</strong
                    >
                </p>
                <p>
                    Se qualsiasi reclamo con noi non viene risolto in modo
                    soddisfacente, è possibile contattare l'Unità di assistenza
                    ai reclami della Divisione dei servizi ai consumatori del
                    Dipartimento degli affari dei consumatori della California
                    per iscritto al 1625 North Market Blvd., Suite N 112,
                    Sacramento, California 95834 o telefonicamente al numero
                    (800) 952-5210 o (916) 445-1254.
                </p>
                <p id="misc">
                    <strong
                        ><strong><strong>25.</strong>&nbsp;</strong>
                        VARIE</strong
                    >
                </p>
                <p>
                    I presenti Termini legali e qualsiasi politica o regola
                    operativa pubblicata da noi sui Servizi o in relazione ai
                    Servizi costituiscono l'intero accordo e intesa tra te e
                    noi. Il nostro mancato esercizio o applicazione di qualsiasi
                    diritto o disposizione delle presenti Condizioni legali non
                    costituirà una rinuncia a tale diritto o disposizione. Le
                    presenti Condizioni legali operano nella misura massima
                    consentita dalla legge. Possiamo cedere parte o tutti i
                    nostri diritti e obblighi ad altri in qualsiasi momento. Non
                    saremo responsabili per eventuali perdite, danni, ritardi o
                    inadempienze causate da qualsiasi causa al di fuori del
                    nostro ragionevole controllo. Se qualsiasi disposizione o
                    parte di una disposizione delle presenti Condizioni legali
                    viene ritenuta illegale, nulla o inapplicabile, tale
                    disposizione o parte di essa è considerata separabile dalle
                    presenti Condizioni legali e non pregiudica la validità e
                    l'applicabilità delle restanti disposizioni. Non esiste
                    alcuna joint venture, partnership, rapporto di lavoro o di
                    agenzia creato tra te e noi a seguito delle presenti
                    Condizioni legali o dell'utilizzo dei Servizi. Accetti che
                    le presenti Condizioni legali non saranno interpretate
                    contro di noi in virtù della loro redazione. Con la presente
                    rinunci a qualsiasi difesa che potresti avere basata sul
                    formato elettronico delle presenti Condizioni legali e sulla
                    mancata firma da parte delle parti del presente documento
                    per l'esecuzione delle presenti Condizioni legali. rapporto
                    di lavoro o di agenzia creato tra te e noi a seguito delle
                    presenti Condizioni legali o dell'utilizzo dei Servizi.
                    Accetti che le presenti Condizioni legali non saranno
                    interpretate contro di noi in virtù della loro redazione.
                    Con la presente rinunci a qualsiasi difesa che potresti
                    avere basata sul formato elettronico delle presenti
                    Condizioni legali e sulla mancata firma da parte delle parti
                    del presente documento per l'esecuzione delle presenti
                    Condizioni legali. rapporto di lavoro o di agenzia creato
                    tra te e noi a seguito delle presenti Condizioni legali o
                    dell'utilizzo dei Servizi. Accetti che le presenti
                    Condizioni legali non saranno interpretate contro di noi in
                    virtù della loro redazione. Con la presente rinunci a
                    qualsiasi difesa che potresti avere basata sul formato
                    elettronico delle presenti Condizioni legali e sulla mancata
                    firma da parte delle parti del presente documento per
                    l'esecuzione delle presenti Condizioni legali.
                </p>
                <p id="contact">
                    <strong
                        ><strong><strong>26.</strong>&nbsp;</strong>
                        CONTATTACI</strong
                    >
                </p>
                <p>
                    Per risolvere un reclamo riguardante i Servizi o per
                    ricevere ulteriori informazioni sull'utilizzo dei Servizi,
                    ti preghiamo di contattarci a:
                </p>
                <p>Nuovo Rinascimento APS</p>
                <p>Via Luigi Nono, 7, 20154 Milano MI, Italy</p>
                <p>Milano, Lombardia</p>
                <p>Italia</p>
                <p>Telefono: (+39)3917700315</p>
                <p>amm.nuovorinascimentoitaliano@gmail.com</p>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.hero {
    > * {
        color: var(--color-subtle) !important;
    }
}
.hero-body {
    @media screen and (max-width: 768px) {
        max-width: 95vw;
    }
    // padding: 0 1rem;
}
p > strong,
li > strong {
    color: var(--color-primary-alt);
    font-weight: 700;
    font-size: 1.2rem;
}
p {
    margin-bottom: 1rem;
}
p > strong {
    display: block;
}
table {
    word-break: break-word;

    border-collapse: collapse;
    border-spacing: 0;
    margin-bottom: 1rem;
    width: 100%;
    border: 1px solid var(--color-primary-alt);
    th,
    td {
        strong {
            color: var(--color-primary-alt);
            font-weight: 700;
            text-transform: uppercase;
        }
        // first child
        &:first-child {
            width: 10rem;
        }
        text-align: left;
        padding: 0.5rem;
        border: 1px solid var(--color-primary-alt);
    }
    th {
        background-color: var(--bg-secondary);
        color: var(--color-subtle);
    }
    tr:nth-child(even) {
        background-color: var(--bg-secondary);
        color: var(--color-subtle);
    }
    tr:nth-child(odd) {
        background-color: var(--bg-secondary);
        color: var(--color-subtle);
    }
}
a {
    color: var(--color-primary) !important;
    // text-decoration: underline;
    text-transform: uppercase;
    font-weight: 700;
    margin: 0 0.25rem;
    display: inline !important;
}

// list styling

ul {
    list-style: none;
    padding-left: 0;
    margin-left: 0;
    // margin-bottom: 1rem;
    li {
        margin-left: 0;
        margin-bottom: 1rem;
        &:before {
            content: "•";
            color: var(--color-primary-alt);
            display: inline-block;
            width: 1rem;
            margin-left: 1rem;
        }
    }
}
</style>
<script>
export default {
    name: "TermsAndConditions",
    data() {
        return {
            pageTitle: "TDF*P — " + this.$t("terms.meta.title"),
            height: "100%",
        };
    },
    layout: "default",

    mounted() {
        this.$store.commit("setCurrPageTitle", this.$t("terms.title"));
        if (this.$i18n.locale === "en") {
            //redirecet to privacy-en
            this.$router.push("/en/terms-en");
        }
        this.enterAnimation();
        // load termly embed script
    },
    head() {
        return {
            title: this.pageTitle,
        };
    },
    watch: {
        $route(to, from) {
            this.$store.commit("setCurrPageTitle", this.$t("terms.title"));
        },
    },

    methods: {
        enterAnimation() {
            const anime = this.$anime;
            anime({
                targets: ".main-content",
                easing: "easeInOutQuad",
                opacity: [0, 1],
                filter: ["blur(2rem)", "blur(0px)"],
                duration: 360,
            });
        },
    },
    beforeMount() {
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
};
</script>
